import { getFileExtension } from './fileExtension'

/**
 * Returns true when the given file name has a .pdf extension.
 */
export function isPdfFileName(fileName: string | undefined | null): boolean {
  return getFileExtension(fileName) === 'pdf'
}
